import React from 'react';
import { Field } from 'formik';
import InnerMoneyField from './InnerMoneyField';
import { MoneyFieldProps } from './types';

const FormikMoneyField = (props: MoneyFieldProps) => {
  const { name, id } = props;

  return (
    <Field name={name ?? id}>
      {({ field, _form, meta }) => <InnerMoneyField field={field} meta={meta} {...props} />}
    </Field>
  );
};

export default FormikMoneyField;
